import React from "react";
import DashboardSectionEmptyState from "./DashboardSectionEmptyState";
import focusTopicsEmptyIcon from "../../../utilities/images/study_dashboard/empty_states/focus_topics.svg";
import "./FocusTopics.css";

const SKELETON_ROW_COUNT = 3;

const getAccuracyClass = (value) => {
  const num = Number(String(value).replace("%", ""));
  if (!Number.isFinite(num)) return "";
  if (num < 30) return "is-low";
  if (num < 70) return "is-mid";
  return "is-high";
};

const FocusTopicsSkeleton = () => (
  <div className="focus-topics__list" aria-hidden="true">
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
      <article key={index} className="focus-topics__item focus-topics__item--skeleton">
        <div className="focus-topics__content">
          <span className="focus-topics__skeleton focus-topics__skeleton--title" />
          <span className="focus-topics__skeleton focus-topics__skeleton--meta" />
        </div>
        <span className="focus-topics__skeleton focus-topics__skeleton--accuracy" />
      </article>
    ))}
  </div>
);

const FocusTopics = ({ topics = [], isLoading = false }) => {
  const showEmpty = !isLoading && !topics.length;

  return (
    <section
      className={`focus-topics${showEmpty ? " focus-topics--empty" : ""}`}
      aria-labelledby="focus-topics-title"
      aria-busy={isLoading || undefined}
    >
      <h2 id="focus-topics-title" className="focus-topics__title">
        This Week&apos;s Focus Topics
      </h2>
      {isLoading ? (
        <FocusTopicsSkeleton />
      ) : showEmpty ? (
        <DashboardSectionEmptyState
          icon={focusTopicsEmptyIcon}
          title="No Focus Topics Yet"
          description="Your recommended topics will appear here based on your performance."
        />
      ) : (
        <div className="focus-topics__list">
          {topics.map((topic) => (
            <article key={topic.id} className="focus-topics__item">
              <div className="focus-topics__content">
                <h3 className="focus-topics__topic">{topic.title}</h3>
                <p className="focus-topics__meta">
                  Questions Attempted :{" "}
                  <strong>{topic.attempted ?? "—"}</strong>
                </p>
              </div>
              <span
                className={`focus-topics__accuracy ${getAccuracyClass(topic.accuracy)}`}
              >
                {topic.accuracy != null ? `${topic.accuracy}%` : "—"} accuracy
              </span>
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default FocusTopics;
